module.exports = __webpack_public_path__ + "static/media/telegram.a451f456.svg";